import { Component } from '@angular/core';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-global-toast',
  standalone: true,
  imports: [ToastModule],
  template: `<p-toast></p-toast>`,
})
export class GlobalToastComponent { }
